import { intersection } from 'underscore';

import { BLAdmin } from '@/types/profile.types';

/* IMPORTANT: THIS IS NOT A CUSTOM HOOK. DO NOT ADD ANY effects IN HERE. e.g., useState, useEffect, etc, */
const userHasRoleOnActiveChannel = (roles: string[], user?: BLAdmin | null) => {
  const channelRoles = user?.channels[user?.active_channel] || [];
  return intersection(roles, channelRoles).length != 0;
};

export default userHasRoleOnActiveChannel;
